import { useState, useRef, useEffect } from "react";
import { getVaultsByStatus } from "../data/vault.service";

export const useVaultsFetchByStatus = ({
    status,
    stopFetching,
    interval = 3000,
}) => {
    const [vaults, setVaults] = useState([]);
    const [isReady, setIsReady] = useState(false);

    const timeoutId = useRef(null);
    useEffect(() => {
        const fetchVaults = async () => {
            const vaults = await getVaultsByStatus(status);
            setVaults(vaults);

            if (stopFetching(vaults)) {
                setIsReady(true);
            } else {
                timeoutId.current = setTimeout(() => fetchVaults(), interval);
            }
        }

        clearTimeout(timeoutId.current);
        fetchVaults();

        return () => {
            clearTimeout(timeoutId.current);
        };
    }, [status, stopFetching, interval]);

    return { vaults, isReady };
}